import React, { useState } from "react";
import IntroSection from "../components/IntroSection";
import NumberedHeading from "../components/NumberedHeading";
import ListView from "../components/ListView";
import DetailGrid from "../components/DetailGrid";
import { detailedResultState } from "../../../utils/recoil";
import { useRecoilState } from "recoil";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Habit = () => {
  const [searchParams] = useSearchParams();
  const [data] = useRecoilState(detailedResultState);
  const [path, setPath] = useState(
    searchParams.get("path") ?? localStorage.getItem("path")
  );
  const { t } = useTranslation("result");

  return (
    <div className="flex flex-col gap-10">
      <IntroSection
        text={
          path !== "student"
            ? data?.workplace_habit?.introduction
            : data?.academic_habit?.introduction
        }
      />
      <NumberedHeading
        number={"1"}
        title={`${t("habits.heading1")} ${path !== "student" ? t("habits.heading2") : t("habits.heading3")} ${t("habits.heading4")}`}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <ListView
        example={true}
        className={"px-[20rem]"}
        data={
          path !== "student"
            ? data?.workplace_habit?.habits
            : data?.academic_habit?.habits
        }
      />
      <DetailGrid
        number={"2"}
        title={`${t("habits.grid1")} ${path !== "student" ? t("habits.grid2") : t("habits.grid3")} ${t("habits.grid4")}`}
        data={
          path !== "student"
            ? data?.workplace_habit?.work_culture
            : data?.academic_habit?.academic_culture
        }
      />
    </div>
  );
};

export default Habit;
